import React from 'react';
import { Box, Paper, Chip, InputAdornment, TextField } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');

const WhatsNewToolbar = ({ searchValue, onSearchChange, applicationFilters, selectedApplication, onSelectApplication, getApplicationCount }) => (
    <Paper elevation={0} className="whats-new-toolbar">
        <Box className="whats-new-search">
            <TextField
                fullWidth
                value={searchValue}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder="Search updates, applications or keywords..."
                variant="standard"
                slotProps={{ input: { disableUnderline: true, startAdornment: <InputAdornment position="start"><SearchRoundedIcon /></InputAdornment> } }}
                className="whats-new-search-field"
            />
        </Box>
        <Box className="whats-new-filters">
            {applicationFilters.map(filter => {
                const isActive = selectedApplication === filter.value;
                const count = getApplicationCount(filter);
                return (
                    <Chip
                        key={filter.value}
                        clickable
                        onClick={() => onSelectApplication(filter.value)}
                        className={cx('whats-new-filter-chip', isActive && 'is-active')}
                        label={
                            <Box component="span" className="whats-new-filter-label">
                                <span>{filter.label}</span>
                                <Box component="span" className={cx('whats-new-filter-count', isActive && 'is-active')}>{count}</Box>
                            </Box>
                        }
                    />
                );
            })}
        </Box>
    </Paper>
);

export default WhatsNewToolbar;
